/* assets/towel-par-calculator.v3.js */
(function () {

  var ROOT_SELECTOR = '[data-towel-parcalc-root]';

  /* ---------------------------
     Utilities
  ---------------------------- */

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function clampInt(v, min) {
    var n = Math.floor(Number(v) || 0);
    return n < (min || 0) ? (min || 0) : n;
  }

  function getNum(root, key) {
    var el = qs(root, '[data-input="' + key + '"]');
    return el ? (Number(el.value) || 0) : 0;
  }

  function getChk(root, key) {
    var el = qs(root, '[data-input="' + key + '"]');
    return !!(el && el.checked);
  }

  function parseOcc(v) {
    if (!v) return null;
    var s = String(v).replace('%', '').trim();
    if (!s) return null;
    var n = Number(s);
    if (!isFinite(n)) return null;
    if (n > 0 && n <= 1) return n * 100;
    return n;
  }

  function recommendPar(occPct) {
    var o = Math.max(0, Math.min(100, occPct));
    if (o <= 50) return 2;
    if (o <= 80) return 3;
    return 4;
  }

  /* ---------------------------
     Slider Fill
  ---------------------------- */

  function syncParFill(ui) {
    if (!ui.parRange) return;

    var min = Number(ui.parRange.min || 1);
    var max = Number(ui.parRange.max || 4);
    var val = Number(ui.parRange.value || 3);

    var pct = ((val - min) / (max - min)) * 100;
    ui.parRange.style.setProperty('--fill', pct + '%');
  }

  /* ---------------------------
     Step Navigation
  ---------------------------- */

  function showStep(ui, n) {
    ui.step = n;

    ui.steps.forEach(function (s) {
      s.classList.toggle(
        'tp-active',
        Number(s.getAttribute('data-step')) === n
      );
    });

    ui.progressBar.style.width =
      ((n / ui.totalSteps) * 100) + '%';

    ui.stepLabels.forEach(function (l) {
      var ln = Number(l.getAttribute('data-steplabel'));
      l.classList.toggle('tp-active', ln === n);
    });

    if (n === 4) syncParFill(ui);

    try {
      ui.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (e) {}
  }

  /* ---------------------------
     Compute Results
  ---------------------------- */

  function computeResults(model) {

    var bathrooms = clampInt(model.bathrooms, 0);
    var PAR = clampInt(model.par, 1);
    PAR = Math.max(1, Math.min(4, PAR));

    var per = {
      bath: clampInt(model.bath, 0),
      hand: clampInt(model.hand, 0),
      wash: clampInt(model.wash, 0),
      mat: clampInt(model.mat, 0)
    };

    var buffers = model.buffers || { pool: 15, gym: 5, spa: 10 };
    var bufferPct = 0;
    var amenities = [];

    if (model.pool) {
      bufferPct += (Number(buffers.pool) || 0) / 100;
      amenities.push('Pool');
    }
    if (model.gym) {
      bufferPct += (Number(buffers.gym) || 0) / 100;
      amenities.push('Gym');
    }
    if (model.spa) {
      bufferPct += (Number(buffers.spa) || 0) / 100;
      amenities.push('Spa');
    }

    var rows = [
      { name: 'Bath Towels', qty: per.bath },
      { name: 'Hand Towels', qty: per.hand },
      { name: 'Washcloths', qty: per.wash },
      { name: 'Bath Mats', qty: per.mat }
    ].map(function (r) {

      var base = bathrooms * r.qty * PAR;
      var total = Math.ceil(base * (1 + bufferPct));

      return {
        name: r.name,
        qty: r.qty,
        base: base,
        total: total
      };
    });

    return {
      bathrooms: bathrooms,
      PAR: PAR,
      bufferPct: bufferPct,
      amenities: amenities,
      rows: rows
    };
  }

  /* ---------------------------
     Render Results
  ---------------------------- */

  function renderResults(ui, model) {

    var bufferText =
      Math.round(model.bufferPct * 100) + '%' +
      (model.amenities.length
        ? ' (' + model.amenities.join(', ') + ')'
        : '');

    ui.summary.innerHTML =
      '<div>' +
        '<div><strong>Bathrooms:</strong> ' + model.bathrooms + '</div>' +
        '<div><strong>PAR:</strong> ' + model.PAR + '</div>' +
        '<div><strong>Amenities buffer:</strong> ' + bufferText + '</div>' +
      '</div>';

    ui.tableWrap.innerHTML =
      '<table class="towel-parcalc__table">' +
        '<thead><tr>' +
          '<th>Item</th>' +
          '<th>Per Bathroom</th>' +
          '<th>Total Towels</th>' +
          '<th>Total Inventory Required</th>' +
        '</tr></thead>' +
        '<tbody>' +
          model.rows.map(function (r) {
            return '<tr>' +
              '<td>' + r.name + '</td>' +
              '<td>' + r.qty + '</td>' +
              '<td>' + r.base + '</td>' +
              '<td><strong>' + r.total + '</strong></td>' +
            '</tr>';
          }).join('') +
        '</tbody>' +
      '</table>';
  }

  /* ---------------------------
     Print (Download via Print-to-PDF)
  ---------------------------- */

  function openPrintWindow(ui) {

    // Ensure results exist before printing
    if (ui.step !== 5 && ui.summary && ui.tableWrap) {
      var model = computeResults({
        bathrooms: getNum(ui.root, 'bathrooms'),
        bath: getNum(ui.root, 'bath'),
        hand: getNum(ui.root, 'hand'),
        wash: getNum(ui.root, 'wash'),
        mat: getNum(ui.root, 'mat'),
        par: getNum(ui.root, 'par') || 3,
        pool: getChk(ui.root, 'pool'),
        gym: getChk(ui.root, 'gym'),
        spa: getChk(ui.root, 'spa'),
        buffers: ui.buffers
      });
      renderResults(ui, model);
      showStep(ui, 5);
    }

    var w = window.open('', '_blank');
    if (!w) return;

    w.document.write(
      '<html><head><title>Towel PAR Results</title>' +
      '<meta name="viewport" content="width=device-width, initial-scale=1">' +
      '<style>' +
      'body{font-family:Arial;padding:24px}' +
      'table{width:100%;border-collapse:collapse}' +
      'th,td{padding:10px;border-bottom:1px solid #ddd}' +
      'th{text-align:left;background:#f2f2f2}' +
      '</style>' +
      '</head><body>' +
      '<h2>Towel PAR Calculator Results</h2>' +
      (ui.summary ? ui.summary.innerHTML : '') +
      (ui.tableWrap ? ui.tableWrap.innerHTML : '') +
      '<script>window.onload=function(){window.print();};<\/script>' +
      '</body></html>'
    );

    w.document.close();
  }

  /* ---------------------------
     Init One Calculator
  ---------------------------- */

  function initOne(root) {

    if (!root || root.getAttribute('data-towel-parcalc-init') === '1') {
      return;
    }

    root.setAttribute('data-towel-parcalc-init', '1');

    var ui = {
      root: root,
      totalSteps: 5,
      step: 1,
      steps: qsa(root, '.towel-parcalc__step'),
      stepLabels: qsa(root, '[data-steplabel]'),
      progressBar: qs(root, '[data-progressbar]'),
      parLabel: qs(root, '[data-parlabel]'),
      parRange: qs(root, '[data-input="par"]'),
      occInput: qs(root, '[data-input="occ"]'),
      suggestOut: qs(root, '[data-suggest-out]'),
      applySuggestBtn: qs(root, '[data-apply-suggest]'),
      summary: qs(root, '[data-summary]'),
      tableWrap: qs(root, '[data-tablewrap]'),
      buffers: {
        pool: Number(root.getAttribute('data-buffer-pool') || 15),
        gym: Number(root.getAttribute('data-buffer-gym') || 5),
        spa: Number(root.getAttribute('data-buffer-spa') || 10)
      }
    };

    if (!ui.progressBar || !ui.steps.length) return;

    /* Slider */
    if (ui.parRange && ui.parLabel) {
      ui.parLabel.textContent = ui.parRange.value;
      syncParFill(ui);
      ui.parRange.addEventListener('input', function () {
        ui.parLabel.textContent = ui.parRange.value;
        syncParFill(ui);
      });
    }

    /* Click Events */
    root.addEventListener('click', function (e) {

      var t = e.target;
      if (!t) return;

      if (t.closest('[data-next]')) {
        showStep(ui, Math.min(ui.totalSteps, ui.step + 1));
        return;
      }

      if (t.closest('[data-back]')) {
        showStep(ui, Math.max(1, ui.step - 1));
        return;
      }

      if (t.closest('[data-reset]')) {
        showStep(ui, 1);
        return;
      }

      if (t.closest('[data-calc]')) {
        var model = computeResults({
          bathrooms: getNum(root, 'bathrooms'),
          bath: getNum(root, 'bath'),
          hand: getNum(root, 'hand'),
          wash: getNum(root, 'wash'),
          mat: getNum(root, 'mat'),
          par: getNum(root, 'par') || 3,
          pool: getChk(root, 'pool'),
          gym: getChk(root, 'gym'),
          spa: getChk(root, 'spa'),
          buffers: ui.buffers
        });

        renderResults(ui, model);
        showStep(ui, 5);
        return;
      }

      if (t.closest('[data-print]') || t.closest('[data-pdf]')) {
        openPrintWindow(ui);
        return;
      }

      if (t.closest('[data-suggest]')) {

        var occ = parseOcc(ui.occInput ? ui.occInput.value : '');
        if (occ == null) {
          if (ui.suggestOut) ui.suggestOut.textContent = 'Enter an occupancy rate (0–100).';
          return;
        }

        var rec = recommendPar(occ);
        if (ui.suggestOut) {
          ui.suggestOut.textContent =
            'Suggested PAR: ' + rec +
            ' (based on ' + Math.round(occ) + '% average occupancy)';
        }
      }

    });

    showStep(ui, 1);
  }

  /* ---------------------------
     Boot
  ---------------------------- */

  function initAll(scope) {
    qsa(scope || document, ROOT_SELECTOR).forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

})();